module.exports = __webpack_public_path__ + "static/lithic-blade-3cb9a82a98c01873805ed4d34f3eb369.png";